<template> 
    <v-card class="mx-auto h100p">
      <v-sheet style="overflow-x: auto; overflow-y: auto" max-height="calc(100vh - 55px)">  
      <!-- <DxScrollView height="420px" :onPullDown="onRefresh"> -->
        <v-card-text class="group-tit py-1"><span class="tit-icon"></span> Status of Man Power on Today ({{toDate}})</v-card-text>
        <table class="status-manpower">
          <thead >
            <tr>
              <th rowspan="2">Division</th>
              <th rowspan="2">Office</th>
              <th :colspan="lengthH">HVS</th>
              <th :colspan="lengthS">Subcont.</th>
              <th rowspan="2">Total</th>
            </tr>
            <tr>
              <!-- HVS columns-->
              <th >Sum.</th>
              <th v-for="(item, index) in headerH" :key="'hvs-' + index">{{item.respNm}}</th>
              <!-- Sub-Con columns-->
              <th >Sum.</th>
              <th v-for="(item, index) in headerS" :key="'sub-' + index">{{item.respNm}}</th>
            </tr>
          </thead>
          <tbody>
            <tr >
              <td >MP</td>
              <td v-for="(item, index) in data" :key="'data-' + index">{{item.mp}}</td>
            </tr>
            <tr >
              <td >Attend - Day</td>
              <td v-for="(item, index) in data" :key="'data-' + index">{{item.attd}}</td>
            </tr>
            <tr >
              <td >Attend - Night</td>
              <td v-for="(item, index) in data" :key="'data-' + index">{{item.attn}}</td>
            </tr>
            <tr >
              <td >Attend Rate</td>
              <td v-for="(item, index) in data" :key="'data-' + index">{{item.rate}}</td>
            </tr>
          </tbody>
        </table>

        <v-card-text class="group-tit py-1"><span class="tit-icon"></span> Blasting Working Blocks</v-card-text>
        <template>
          <div>
            <table class="status-manpower">
              <colgroup>
                <col style="width:25%" />
                <col style="width:25%" />
                <col style="width:25%" />
              </colgroup>
              <thead>
                <tr>
                  <th>Division</th>
                  <th>No1</th>
                  <th>No2</th>
                  <th>No3</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(item, index) in datas">
                  <tr v-if="shouldShowRowspan(index, item.div)">
                    <td :rowspan="getRowspan(item.div)" style="vertical-align: middle;">
                      {{ item.div }}
                    </td>
                    <td>{{ item.bs01 }}</td>
                    <td>{{ item.bs02 }}</td>
                    <td>{{ item.bs03 }}</td>
                  </tr>
                  <tr v-else >
                    <td>{{ item.bs01 }}</td>
                    <td>{{ item.bs02 }}</td>
                    <td>{{ item.bs03 }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </template>
      </v-sheet>  
      <!-- </DxScrollView> -->
    </v-card> 
</template>

<script>
import { DxScrollView } from 'devextreme-vue/scroll-view'
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';
import moment from 'moment';
import notify from 'devextreme/ui/notify' // message
import EventBus from '@/components/event-bus'
import { dockStatus, 
         dailyManpower, 
         blastingBlockList, 
         inspectionBlockList,  } from '@/api/view/pp/20/v20a6000.js'

export default {

  components: { 
    DxDataGrid, 
    DxColumn, 
    DxScrollView  
  },
  name: "statusManpower",
  data() {
    return {
      toDate: moment().format('YYYY-MM-DD'),
      //For M/P
      headerH: [],
      headerS: [],
         data: [],          
      lengthH: 0,
      lengthS: 0,
      //For Blasting Block
      datas: [],
      cntBlastBlock: 0,
      cntDailyMP: 0,
    };
  },
  mounted() {
    this.datas = [];
    this.data = [];

    this.doSearchBlastingList();

    this.doSearchDailyMP();
  },
  methods: {
    onRefresh(e) {
      setTimeout(() => {
        e.component.release(); // Kết thúc hiệu ứng loading
        alert("Đã làm mới dữ liệu!");
      }, 1000);
    },
    async doSearchDailyMP() {
      try {
        // this.openLoading('Loading...')
        const res = await dailyManpower();
        this.headerH = [];
        this.headerS = [];
        // await dailyManpower().then(res => {
          // console.log('res', res);
          if (res.list.length > 0) {
            this.data = res.list           
            this.cntDailyMP = res.list.length 
            // console.log('length', res.list.length);
            // for (var i = 0; i < res.list.length; i++) {
            res.list.forEach(item => {  
              if (item.sgbn === '3') this.headerH.push({ respNm: item.respnm });
              if (item.sgbn === '6') this.headerS.push({ respNm: item.respnm });
              // if(res.list[i].sgbn === '3') {
              //   this.headerH.push({respNm:  res.list[i].respnm})
              // }

              // if(res.list[i].sgbn === '6') {
              //   this.headerS.push({respNm:  res.list[i].respnm})
              // }
              
            });

            this.lengthH = this.headerH.length + 1
            this.lengthS = this.headerS.length + 1
            // console.log('######lengthH===>', this.lengthH)
            // console.log('######lengthS===>', this.lengthS)
          } else {
            // this.data.splice(0)
            this.data = [];
            this.cntDailyMP = 0
          }
          // console.log('######cntDailyMP===>', this.data)
        // })
      } catch (err) {
        console.error("Error fetching manpower data:", err);
      }
    },

    async doSearchBlastingList() {
      try {
        // this.openLoading('Loading...')

        await blastingBlockList().then(res => {
          // console.log('res', res);
          if (res.list.length > 0) {
            this.datas = res.list
            this.cntBlastBlock = res.list.length 
            // console.log('length', res.list.length);
          } else {
            this.datas.splice(0)
             this.cntBlastBlock = 0
          }
          // console.log('######cntBlastBlock===>', this.datas)
        })
      } finally {
        // this.endLoading()
      }
    },

    getRowspan(value) {
      // console.log(category);
      return this.datas.filter((item) => item.div === value).length;
    },
    shouldShowRowspan(index, value) {
      // console.log(category);
      return this.datas.findIndex((item) => item.div === value) === index;
    },
    
  }
}
</script>

<style>
  table, td, th {
    border: 1px solid;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  .status-manpower{
      width: calc(98% - 15px);
      font-size: 9pt; 
      margin: 10px 15px;
      border: 1px solid #d4e5f9;
      border-radius: 4px;
      text-align: center;
      height: calc(30% - 40px);
    
  }
  .status-manpower th{
      font-size: 9pt;
      color: #444;
      background-color: #e7e8ef;
      border: 1px solid #c9d5e3;
      padding: 2px 0;

  }
  .status-manpower .td-titsub-bg{
      background-color: #f1f2f6;
  }
  .status-manpower td{
      border: 1px solid #c9d5e3;
      padding: 5px 0;
  }


</style>